module.exports = __webpack_public_path__ + "static/media/spotify-rond..af9cbcee.png";